module.exports = __webpack_public_path__ + "static_pc/img/6.3b9f0697.png";